module.exports = __webpack_public_path__ + "static/img/transition.b91309c7.png";